// import { addResizeListener, removeResizeListener } from "element-ui/src/utils/resize-event";
import virtualWrapper from "./virtual";
import dsfElTableBody from "./body";

export default {
  name: "DsfElTable",
  mixins: [ELEMENT.Table],
  components: { virtualWrapper, TableBody: dsfElTableBody },
  provide() {
    return {
      $dsfElTable: this
    };
  },
  data() {
    this.tbodys = {};
    this.preStartIndex = 0;
    this.scrollY = 0;
    this.fastScroll = false;
    return {
      // cssScoped: dsf.uuid(),
      startIndex: 0,
      endIndex: 0,
      translateY: 0,
      rowHeights: []
      // bodyObserverDisabled:false
      // styleStr: ""
    };
  },
  props: {
    virtualScroll: {
      type: Boolean,
      default() {
        return false;
      }
    },
    virtualScrollRowHeight: {
      type: Number,
      default: 46
    }
  },
  computed: {
    minRowHeight() {
      return this.virtualScrollRowHeight;
    },
    useVirtulScroll() {
      //如果自适应高度属性为true且spanMethod为空
      return this.virtualScroll && this.height && this.height != "auto" && dsf.isUnDef(this.spanMethod);
    },
    scrollHeight() {
      return this.data.length * this.minRowHeight;
    },
    $translateY() {
      if (!this.useVirtulScroll) {
        return 0;
      }
      return this.translateY;
    }
  },
  mounted() {},
  beforeDestroy() {
    delete this.startIndex;
    delete this.endIndex;
    delete this.preStartIndex;
    delete this.scrollY;
  },
  destroyed() {
    delete this.tbodys;
  },
  updated() {},
  created() {
    this._doLayout = ELEMENT.Table.methods.doLayout;
    // this._layoutUpdateScrollY = this.layout.updateScrollY;
    // this._layoutUpdateElsHeight = this.layout.updateElsHeight();
    this._handleFixedMousewheel = ELEMENT.Table.methods.handleFixedMousewheel;
    this.layout.updateScrollY = function () {
      const height = this.height;
      if (height === null) return false;
      const bodyWrapper = this.table.bodyWrapper;
      let body = null;
      if (this.table.$el && bodyWrapper) {
        if (this.table.useVirtulScroll) {
          body = bodyWrapper.querySelector(".el-table__virtual-wrapper");
        } else {
          body = bodyWrapper.querySelector(".el-table__body");
        }
        const prevScrollY = this.scrollY;
        const scrollY = body.offsetHeight > this.bodyHeight;
        this.scrollY = scrollY;
        return prevScrollY !== scrollY;
      }
      return false;
    };
    // this.layout.updateElsHeight = function () {
    //   let result = this._layoutUpdateElsHeight.call(this.layout);
    //   return result;
    // };
  },
  methods: {
    handleFixedMousewheel(event, data) {
      if (this.useVirtulScroll) {
        const virtualBox = this.$refs.virtualBox;
        if (Math.abs(data.spinY) > 0) {
          const currentScrollTop = virtualBox.scrollTop;
          if (data.pixelY < 0 && currentScrollTop !== 0) {
            event.preventDefault();
          }
          if (data.pixelY > 0 && virtualBox.scrollHeight - virtualBox.clientHeight > currentScrollTop) {
            event.preventDefault();
          }
          virtualBox.scrollTop += Math.ceil(data.pixelY / 5);
        } else {
          virtualBox.scrollLeft += Math.ceil(data.pixelX / 5);
        }
      } else {
        this._handleFixedMousewheel.call(this, event, data);
      }
    },
    getFixed(fixed) {
      if (fixed == "left" || fixed == "right") {
        return fixed;
      } else if (fixed === true) {
        return "left";
      } else {
        return "main";
      }
    },
    doLayout(isSyncRowHeight = true) {
      return new Promise((resolve) => {
        this._doLayout();
        if (isSyncRowHeight) {
          this.doLayoutUpdateRowHeight();
        }
        if (this.useVirtulScroll && this.data.length) {
          // this.createEnterViewRows();
          this.getViewVisableData();
          this.$nextTick(() => {
            this.resetVirtualWrapperTranslateY();
            this._doLayout();
            resolve();
          });
        }
      });
    },
    virtualBoxScrollHandler(evt) {
      let scrollTop = evt.target.scrollTop;
      let scrollLeft = evt.target.scrollLeft;
      this.$refs.bodyWrapper.scrollTo(scrollLeft, scrollTop);
      if (this.$refs.fixedBodyWrapper) {
        this.$refs.fixedBodyWrapper.scrollTop = scrollTop;
      }
      if (this.$refs.rightFixedBodyWrapper) {
        this.$refs.rightFixedBodyWrapper.scrollTop = scrollTop;
      }
      // let scrollTop = bodyWrapper.scrollTop;
      if (this.scrollY == scrollTop) {
        return;
      }
      this.scrollY = scrollTop;
      this.preStartIndex = this.startIndex;
      this.getViewVisableData();
      this.translateY = this.setTranslateY();
      this.preStartIndex = this.startIndex;
      this.$emit("virtual-scroll", evt);
      this.debounceScrollEnded();
    },
    debounceScrollEnded() {
      const scrollingResetTimeInterval = 150;
      const { disablePointerEventsTimeoutId } = this;
      if (disablePointerEventsTimeoutId) {
        this.cancelAnimationTimeout(disablePointerEventsTimeoutId);
      }
      this.disablePointerEventsTimeoutId = this.requestAnimationTimeout(this.debounceScrollEndedCallback, scrollingResetTimeInterval);
    },
    cancelAnimationTimeout(clearId) {
      window.cancelAnimationFrame(clearId);
    },
    requestAnimationTimeout(callback, delay) {
      let start;
      Promise.resolve().then(() => {
        start = Date.now();
      });

      const timeout = () => {
        // console.log(Date.now() - start);
        if (Date.now() - start >= delay) {
          callback.call();
        } else {
          frame.id = window.requestAnimationFrame(timeout);
        }
      };
      const frame = {
        id: window.requestAnimationFrame(timeout)
      };

      return frame;
    },
    debounceScrollEndedCallback() {
      this.disablePointerEventsTimeoutId = null;
      this.fastScroll = false;
    },
    doLayoutUpdateRowHeight() {
      if (this?.tbodys?.["main"]) {
        let body = this.tbodys["main"];
        body._syncRowHeight();
        return this.$nextTick();
      }
    },
    updateScrollHeight() {
      let sb = 0;
      _.each(this.rowPosition || [], (it) => {
        sb += it.height;
      });
      this.scrollHeight = sb;
    },
    createEnterViewRows(boxRect) {
      this.viewRowIndex = [];
      if (!boxRect) {
        let bodyWrapper = this.$refs.bodyWrapper;
        let box = bodyWrapper?.getBoundingClientRect?.();
        if (box) {
          boxRect = {
            top: 0,
            height: box.height,
            scrollTop: bodyWrapper.scrollTop || 0
          };
        } else {
          boxRect = { top: 0, height: 0, scrollTop: 0 };
        }
      }
      let top = boxRect.top;
      let bottom = boxRect.top + boxRect.height;
      let offset = 0;
      let min = 0,
        max = 0;
      let first = false;
      for (let i = 0; i < this.data.length; i++) {
        let rowTop = offset;
        let rowBottom = rowTop + this.minRowHeight;
        rowTop -= boxRect?.scrollTop || 0;
        rowBottom -= boxRect?.scrollTop || 0;
        offset += this.minRowHeight;
        if (rowTop <= bottom + 10 && rowBottom >= top - 10) {
          this.viewRowIndex.push(i);
          if (!first) {
            first = true;
            min = i;
          }
        }
        max = i;
      }
      this.preStartIndex = this.startIndex;
      this.startIndex = min;
      this.endIndex = max;
    },
    getViewVisableData(boxRect) {
      let area = this.getViewVisableDataIndex(boxRect);
      this.preStartIndex = this.startIndex;
      this.startIndex = area.startIndex;
      this.endIndex = area.endIndex;
    },
    getViewVisableDataIndex(boxRect) {
      let startIndex, endIndex;
      if (!boxRect) {
        let bodyWrapper = this.$refs.bodyWrapper;
        let box = bodyWrapper?.getBoundingClientRect?.();
        if (box) {
          boxRect = {
            top: 0,
            height: box.height,
            scrollTop: bodyWrapper.scrollTop || 0
          };
        } else {
          boxRect = { top: 0, height: 0, scrollTop: 0 };
        }
      }
      let top = boxRect.top;
      let bottom = boxRect.top + boxRect.height;
      let offset = 0;
      let min = 0,
        max = 0;
      let first = false;
      for (let i = 0; i < this.data.length; i++) {
        let rowTop = offset;
        let rowBottom = rowTop + this.minRowHeight;
        rowTop -= boxRect?.scrollTop || 0;
        rowBottom -= boxRect?.scrollTop || 0;
        offset += this.minRowHeight;
        if (rowTop <= bottom + 10 && rowBottom >= top - 10) {
          if (!first) {
            first = true;
            min = i;
          }
          max = i;
        }
      }
      // startIndex = min - 8 < 0 ? 0 : min - 8;
      // endIndex = max + 8 >= this.data.length ? this.data.length - 1 : max;
      startIndex = min;
      endIndex = max;
      return {
        startIndex,
        endIndex
      };
    },
    setTranslateY() {
      let y = 0;
      let startIndex = this.startIndex;
      y = startIndex * this.minRowHeight;
      return y;
    },
    resetVirtualWrapperTranslateY() {
      this?.$refs?.fixedVirtualWrapper?.changeTranslateY?.();
    }
  },
  watch: {
    // "$system.setting.fontSize": {
    //   handler(v, ov) {
    //     debugger;
    //   }
    // },
    data: {
      immediate: true,
      handler(v, ov) {
        if (this.useVirtulScroll) {
          this.$nextTick(() => {
            this.getViewVisableData();
          });
        }
      }
    }
  },
  render(h) {
    let vnodes = ELEMENT.Table.render.call(this, h);
    let bodyWrapper = _.find(vnodes.children || [], (vn) => {
      return vn?.data?.ref == "bodyWrapper";
    });
    //表格主体加入虚拟滚动
    if (bodyWrapper) {
      let emptyBlock = _.find(bodyWrapper.children || [], (vn) => {
        return vn?.data?.ref == "emptyBlock";
      });
      if (emptyBlock) {
        dsf.array.remove(bodyWrapper.children, emptyBlock);
      }
      let node = (
        <virtual-wrapper ref="virtualWrapper" fixedPosition={"main"}>
          {bodyWrapper.children}
        </virtual-wrapper>
      );
      bodyWrapper.children = [node];
      if (emptyBlock) {
        bodyWrapper.children.push(emptyBlock);
      }
      // bodyWrapper.children.push(h('div',{
      //   ref:"cloneTable",
      //   style:{
      //     width:"1px",
      //     height:"1px",
      //     overflow:"hidden"
      //   }
      // }))
    }

    //虚拟滚动容器
    if (this.useVirtulScroll) {
      let width = 0;
      //标识表格横向撑满屏幕,但存在纵向滚动条
      if (this.layout.scrollY && !this.layout.scrollX) {
        width = this.layout.bodyWidth - this.layout.gutterWidth;
      } else {
        width = this.layout.bodyWidth;
      }
      let index = _.findIndex(vnodes.children, (vn) => {
        return vn == bodyWrapper;
      });
      let boxNode = (
        <div
          ref="virtualBox"
          style={{
            position: "absolute",
            top: this.unitSize(this.layout.headerHeight),
            left: "0px",
            right: "0px",
            bottom: "0px",
            overflow: "auto"
          }}
          on-scroll={this.virtualBoxScrollHandler}
        >
          <div
            style={{
              width: this.unitSize(width),
              height: this.unitSize(this.scrollHeight)
            }}
          ></div>
        </div>
      );
      bodyWrapper.data.style[0].overflow = "hidden";
      if (this.layout.scrollY) {
        bodyWrapper.data.style.push({ width: `calc(100% - ${this.unitSize(this.layout.gutterWidth)})` });
      }
      if (this.layout.scrollX) {
        bodyWrapper.data.style[0].height = `calc(${this.unitSize(this.layout.bodyHeight)} -  ${this.unitSize(this.layout.gutterWidth)})`;
      }
      vnodes.children.splice(index, 0, boxNode);
    }

    // 左侧固定区域加入虚拟滚动
    let fixedWrapper = _.find(vnodes.children || [], (vn) => {
      return vn?.data?.ref == "fixedWrapper";
    });
    let fixedBodyWrapper = _.find(fixedWrapper?.children || [], (vn) => {
      return vn?.data?.ref == "fixedBodyWrapper";
    });
    if (fixedBodyWrapper) {
      let node = (
        <virtual-wrapper ref="fixedVirtualWrapper" fixedPosition={"left"}>
          {fixedBodyWrapper.children}
        </virtual-wrapper>
      );
      fixedBodyWrapper.children = [node];
    }

    //右侧固定区域加入虚拟滚动
    let rightFixedWrapper = _.find(vnodes.children || [], (vn) => {
      return vn?.data?.ref == "rightFixedWrapper";
    });
    let rightFixedBodyWrapper = _.find(rightFixedWrapper?.children || [], (vn) => {
      return vn?.data?.ref == "rightFixedBodyWrapper";
    });
    if (rightFixedBodyWrapper) {
      let node = (
        <virtual-wrapper ref="rightFixedVirtualWrapper" fixedPosition={"right"}>
          {rightFixedBodyWrapper.children}
        </virtual-wrapper>
      );
      rightFixedBodyWrapper.children = [node];
    }
    return vnodes;
  }
};
